import {lazy} from 'react';

export const lazyMin = (
	factory: () => Promise<{default: React.ComponentType<any>}>,
	minDelay = 200,
) => {
	return lazy(async () => {
		return Promise.all([
			factory(),
			new Promise((resolve) => setTimeout(resolve, minDelay)),
		]).then(([moduleExports]) => moduleExports);
	});
};
